import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SAMPLE_IMG_HEART_HOOPS } from "@/data/products";

const BrandStory = () => {
  return (
    <section className="py-16 lg:py-28" style={{ background: "#FDF6F0" }} data-testid="brand-story">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="gold-divider" />
              <span className="overline">Our Story</span>
            </div>
            <h2 className="font-serif text-plum leading-[1.05] tracking-tight" style={{ fontSize: "clamp(34px, 4.4vw, 56px)" }}>
              Born from one <br />
              <span className="italic text-blush">simple belief.</span>
            </h2>
            <p className="mt-7 text-plum/70 leading-relaxed text-[15px] lg:text-base max-w-[460px]">
              GirlyGrove was born from one simple belief: every woman deserves jewelry that
              makes her feel <em className="text-blush not-italic font-medium">seen</em>. We
              curate pieces that tell your story — from Korean minimalism to bold festive glow,
              from quiet mornings to golden hours.
            </p>
            <p className="mt-4 text-plum/70 leading-relaxed text-[15px] lg:text-base max-w-[460px]">
              Tarnish-free, hypoallergenic, and made for the woman who knows exactly what she wants.
            </p>
            <a
              href="#"
              className="mt-8 inline-flex items-center gap-2 text-sm tracking-[0.18em] uppercase text-gold hover:text-blush transition-colors"
              data-testid="brand-story-cta"
            >
              Read our story <ArrowUpRight size={14} />
            </a>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2 relative">
            <div className="grid grid-cols-6 grid-rows-6 gap-3 lg:gap-4 h-[420px] sm:h-[520px] lg:h-[600px]">
              <div className="col-span-4 row-span-6 col-start-1 row-start-1 relative overflow-hidden rounded-[24px] bg-pearl">
                <img
                  src={SAMPLE_IMG_HEART_HOOPS}
                  alt="GirlyGrove craftsmanship"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="col-span-2 row-span-6 col-start-5 row-start-1 relative rounded-[24px] flex flex-col items-center justify-center text-center p-4" style={{ background: "#FBEAF0" }}>
                <p className="font-serif italic text-plum text-5xl lg:text-6xl leading-none">50k+</p>
                <p className="overline text-plum/70 mt-3">Happy Customers</p>
                <span className="my-5 gold-divider" />
                <p className="font-serif italic text-plum text-2xl lg:text-3xl leading-tight">Tarnish<br/>free</p>
                <p className="overline text-plum/70 mt-2">Premium finish</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandStory;
